import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function BookingCancel() {
  const { t } = useLang();
  return (
    <div data-testid="booking-cancel-page" className="min-h-screen bg-sand flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center py-16">
        <XCircle className="mx-auto text-forest" size={64} />
        <h1 className="font-display text-4xl md:text-5xl mt-6 text-jungle">{t.cancel.title}</h1>
        <p className="mt-4 text-forest text-lg">{t.cancel.subtitle}</p>
        <Link to="/#book" data-testid="cancel-back-btn" className="btn-primary mt-8 inline-flex">{t.cancel.back}</Link>
      </div>
    </div>
  );
}
